import { LocalShipping, Message } from '@mui/icons-material'
import { AppealsList } from 'feature/appeals/components'
import {
  getActiveAppeals,
  getCompletedAppeals,
} from 'feature/appeals/helpers/filterAppeals'
import { useGetAppealsQuery } from 'feature/appeals/redux/appeals.api'
import { useMemo, useState } from 'react'
import useRequestTimeout from 'router/hooks/useRequestTimeout'
import { LoaderInCentalPosition } from 'widget'
import { EmptyInformationBlock } from 'widget/EmptyInformationBlock/EmptyInformationBlock'

import style from './Appeals.module.scss'

// страница со списком заявок
export function Appeals() {
  const [isExpandedActive, setExpandedActive] = useState<boolean>(true)
  const [isExpandedDone, setExpandedDone] = useState<boolean>(true)
  const { isTimeUp, Modal } = useRequestTimeout()

  const { data, isLoading } = useGetAppealsQuery(undefined, {
    pollingInterval: 10000,
    skip: isTimeUp,
  })

  const activeAppealsList = useMemo(
    () => (data ? getActiveAppeals(data) : []),
    [data],
  )
  const completedAppealsList = useMemo(
    () => (data ? getCompletedAppeals(data) : []),
    [data],
  )

  const isListEmpty = !activeAppealsList.length && !completedAppealsList.length

  return (
    <>
      <div className={style.header}>
        <LocalShipping color='primary' />
        <span className='h1'>Обращения</span>
      </div>

      <section className={style.appeals}>
        {isLoading && <LoaderInCentalPosition className={style.loader} />}
        {!!activeAppealsList?.length && (
          <AppealsList
            title='активные'
            onClick={setExpandedActive}
            isExpanded={isExpandedActive}
            orderList={activeAppealsList}
          />
        )}

        {!!completedAppealsList?.length && (
          <AppealsList
            title='завершенные'
            onClick={setExpandedDone}
            isExpanded={isExpandedDone}
            orderList={completedAppealsList}
          />
        )}
        {isListEmpty && !isLoading && (
          <div className={style.empty}>
            <EmptyInformationBlock
              title='Здесь будут ваши обращения'
              Icon={Message}
            />
          </div>
        )}
      </section>
      {Modal}
    </>
  )
}
